/*! main.js | Bulkit | CSS Ninja */

/* ==========================================================================
Core JS file
========================================================================== */

'use strict'

if (typeof window !== 'undefined' && typeof window.initThemeSwitcher !== 'function') {
  window.initThemeSwitcher = function () {}
}

//1. Preload page
initPageLoader()

$(document).ready(function ($) {
  //2. Lazy loading
  const el = document.querySelectorAll('[data-lazy-load]')
  const observer = lozad(el, {
    loaded: function (el) {
      // Custom implementation on a loaded element
      el.parentNode.classList.add('loaded')
    },
  })

  observer.observe()

  //3. Change to demo content (if env)
  if (env === 'development') {
    changeDemoImages()
  }

  //4. Init Feather icons
  feather.replace()

  //5. Init Layout
  initNavbar()
  initLandingNavbar()
  initMobileMenu()
  initLandingMobileMenu()
  initEcommerceNavbar()
  initNavbarDropdown()
  initSidebar()
  initThemeSwitcher()
  initBackgroundImages()

  //6. Components
  initSlider()
  initDropdowns()
  initTabsNav()
  initNavigationTabs()
  initVerticalTabs()
  initMediaCards()
  initTiltCards()
  initPopovers()
  initTooltips()
  initModals()
  initCounters()
  initSimpleAccordion()
  initAccordions()
  initToasts()
  initCountdown()

  //7. Carousels
  initBasicCarousel()
  initVerticalCarousel()
  initFlatCarousel()
  initImageCarousel()
  initSingleImageCarousel()
  initMultipleImagesCarousel()

  //8. Forms
  initDatepicker()
  initTimepicker()
  initDatepickerAlt()
  initChosenSelects()
  initMaterialSelect()
  initAutocompletes()
  initFileInputs()
  initRangeInput()
  initRangeInputs()
  initJqueryTagInput()
  initBulmaTags()
  initBulmaSteps()
  initBulmaIconpicker()
  initBulmaCalendar()
  initComboBox()
  initImageComboBox()
  initStackedComboBox()
  initFileUploader()

  //9. Video
  initVideoEmbed()
  initBackgroundVideo()
  initPlayers()

  //10. Demo
  initDemo()
  initScrollspyNav()
  initParallax()
  initBackToTop()

  //11. Utility functions
  initGitem()
  initAnchorScroll()
  initQuickview()
  initScrollReveal()
  initMarquee()

  //12. Page specific methods
  initMockup()
  initClientsCarousel()
  initPeopleCarousel()
  initCustomCarousel()
  initCarousel()
  initLandingCarousel()
  initTestimonials()
  initCharacterTestimonials()
  initPricing()
  initPricingCarousel()
  initTabbedPricing()
  initFreelancerPricing()
  initSwitchPricing()
  initBoxedPricing()
  initOnePagePricing()
  //initBlog();
  initSearchBox()
  initNavigationDots()
  initFaq()
  initAuth()
  initAnimations()
  initCanvas()
  initParticles()
  initAnimatedSvg()
  initChatWidget()
  initContactToggler()
  initGoogleMap()
  initMapBox()
  initCodeTabs()
  initLanguageSelector()
})

var BREWSKI_LANGUAGE_KEY = 'brewskiLang'
var BREWSKI_DEFAULT_LANG = 'en'
var BREWSKI_LANGUAGES = {
  en: {
    heroTitle: '<strong>Free</strong> brewery management system',
    heroSubtitle:
      'Designed with small producers in mind, focusing on making brewing fun with as little paperwork as possible.',
    ctaLogin: 'Login',
    ctaRegister: 'Register',
    sectionHeading: 'First class brewery management',
  },
  de: {
    heroTitle: '<strong>Kostenloses</strong> Brauereimanagement-System',
    heroSubtitle:
      'Entwickelt für kleine Produzenten, damit Brauen mit so wenig Papierarbeit wie möglich Spaß macht.',
    ctaLogin: 'Anmelden',
    ctaRegister: 'Registrieren',
    sectionHeading: 'Erstklassiges Brauereimanagement',
  },
  es: {
    heroTitle: 'Sistema <strong>gratuito</strong> de gestión cervecera',
    heroSubtitle:
      'Diseñado pensando en los pequeños productores, para que la elaboración sea divertida con la menor burocracia posible.',
    ctaLogin: 'Iniciar sesión',
    ctaRegister: 'Registrarse',
    sectionHeading: 'Gestión cervecera de primera clase',
  },
  fr: {
    heroTitle: 'Système <strong>gratuit</strong> de gestion de brasserie',
    heroSubtitle:
      'Conçu pour les petits producteurs, afin de rendre le brassage amusant avec le moins de paperasse possible.',
    ctaLogin: 'Connexion',
    ctaRegister: "S'inscrire",
    sectionHeading: 'Gestion de brasserie de premier ordre',
  },
  cs: {
    heroTitle: '<strong>Bezplatný</strong> systém pro správu pivovaru',
    heroSubtitle:
      'Navrženo pro malé výrobce, aby bylo vaření piva zábavné s co nejmenším množstvím papírování.',
    ctaLogin: 'Přihlásit se',
    ctaRegister: 'Registrovat se',
    sectionHeading: 'Špičková správa pivovaru',
  },
}

var BREWSKI_LANGUAGE_LABELS = {
  en: 'English',
  de: 'Deutsch',
  es: 'Español',
  fr: 'Français',
  cs: 'Čeština',
}

function initLanguageSelector() {
  if (typeof window === 'undefined') {
    return
  }

  const activeLang = resolveBrewskiLanguage()
  applyBrewskiTranslations(activeLang)

  document.querySelectorAll('.language-selector [data-lang]').forEach((item) => {
    item.addEventListener('click', (event) => {
      event.preventDefault()
      const selected = item.getAttribute('data-lang')
      if (!selected || !BREWSKI_LANGUAGES[selected]) {
        return
      }
      storeBrewskiLanguage(selected)
      applyBrewskiTranslations(selected)
    })
  })
}

function resolveBrewskiLanguage() {
  const stored = getStoredBrewskiLanguage()
  if (stored && BREWSKI_LANGUAGES[stored]) {
    return stored
  }

  const browser = (navigator.language || navigator.userLanguage || '').slice(0, 2).toLowerCase()
  if (browser && BREWSKI_LANGUAGES[browser]) {
    return browser
  }

  return BREWSKI_DEFAULT_LANG
}

function applyBrewskiTranslations(lang) {
  const translations = BREWSKI_LANGUAGES[lang] || BREWSKI_LANGUAGES[BREWSKI_DEFAULT_LANG]

  document.documentElement.setAttribute('lang', lang)

  document.querySelectorAll('[data-i18n]').forEach((element) => {
    const key = element.getAttribute('data-i18n')
    if (key && translations[key]) {
      const value = translations[key]
      if (value.indexOf('<') !== -1) {
        element.innerHTML = value
      } else {
        element.textContent = value
      }
    }
  })

  document.querySelectorAll('.language-selector').forEach((selector) => {
    const link = selector.querySelector('.navbar-link')
    if (link && BREWSKI_LANGUAGE_LABELS[lang]) {
      link.textContent = BREWSKI_LANGUAGE_LABELS[lang]
    }

    selector.querySelectorAll('[data-lang]').forEach((item) => {
      const itemLang = item.getAttribute('data-lang')
      if (!itemLang) {
        return
      }
      if (itemLang === lang) {
        item.classList.add('is-active')
      } else {
        item.classList.remove('is-active')
      }
    })
  })
}

function getStoredBrewskiLanguage() {
  try {
    return localStorage.getItem(BREWSKI_LANGUAGE_KEY)
  } catch (error) {
    return null
  }
}

function storeBrewskiLanguage(lang) {
  try {
    localStorage.setItem(BREWSKI_LANGUAGE_KEY, lang)
  } catch (error) {
    // Storage might be unavailable; fail silently.
  }
}
